import { Storage } from "../../Interfaces/@core";
import { GetHashed } from "../Helper";

/**
 * A utility for storing and retrieving values using Web Storage (sessionStorage or localStorage).
 * All keys are hashed to prevent key collisions and obfuscate sensitive keys.
 */
export const GlobalState = {
  /**
   * Stores a value under a hashed key in the specified storage.
   *
   * @param key - The key to identify the stored value.
   * @param value - The value to store.
   * @param storage_type - The storage object to use (default is sessionStorage).
   */
  set(
    key: string,
    value: string,
    storage_type: Storage = sessionStorage,
  ): void {
    storage_type.setItem(GetHashed(key), value);
  },

  /**
   * Retrieves a value by its hashed key from the specified storage.
   *
   * @param key - The key to retrieve.
   * @param storage_type - The storage object to use (default is sessionStorage).
   * @returns The value as a string or null if not found.
   */
  get(key: string, storage_type: Storage = sessionStorage): string | null {
    return storage_type.getItem(GetHashed(key));
  },

  /**
   * Removes a value by its hashed key from the specified storage.
   *
   * @param key - The key to remove.
   * @param storage_type - The storage object to use (default is sessionStorage).
   */
  remove(key: string, storage_type: Storage = sessionStorage): void {
    storage_type.removeItem(GetHashed(key));
  },

  /**
   * Clears all stored key-value pairs from the specified storage.
   *
   * @param storage_type - The storage object to clear (default is sessionStorage).
   */
  reset(storage_type: Storage = sessionStorage): void {
    storage_type.clear();
  },
};
